<template>
  <div>
    <!-- Loading -->
    <div v-if="isLoading" class="text-center py-12">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
      <p class="mt-4 text-gray-600 dark:text-gray-400">Laden...</p>
    </div>

    <!-- Error -->
    <div
      v-else-if="error"
      class="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
    >
      <p class="text-red-800 dark:text-red-300">
        Fout bij laden van begrotingsdata: {{ error.message }}
      </p>
    </div>

    <template v-else>
      <!-- Empty state -->
      <div
        v-if="groupedYears.length === 0"
        class="text-center py-8 text-gray-500 dark:text-gray-400 text-sm"
      >
        Geen begrotingsdata ingevoerd. Selecteer een jaar om te beginnen.
      </div>

      <!-- Year cards -->
      <div v-else class="space-y-4">
        <div
          v-for="yearGroup in groupedYears"
          :key="yearGroup.year"
          class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden"
        >
          <div
            class="flex items-center justify-between px-4 py-3 bg-gray-50 dark:bg-gray-900/50 cursor-pointer"
            @click="$emit('edit', yearGroup.year)"
          >
            <div>
              <span class="font-semibold text-gray-900 dark:text-white">{{ yearGroup.year }}</span>
              <span class="ml-3 text-sm text-gray-500 dark:text-gray-400">
                Uren: {{ formatCurrency(yearGroup.totalHours) }} | 3e omzet:
                {{ formatCurrency(yearGroup.totalDerden) }} | Behaalde 3e:
                {{ formatCurrency(yearGroup.totalActualDerden) }}
              </span>
            </div>
            <div class="flex items-center gap-2">
              <button
                @click.stop="$emit('edit', yearGroup.year)"
                class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm font-medium"
              >
                Bewerken
              </button>
              <button
                @click.stop="$emit('delete-year', yearGroup.year)"
                class="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 text-sm font-medium"
              >
                Verwijderen
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  budgets: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
  error: { type: Object, default: null }
})

defineEmits(['edit', 'delete-year'])

const groupedYears = computed(() => {
  const map = {}
  for (const b of props.budgets) {
    if (!map[b.year]) {
      map[b.year] = {
        year: b.year,
        totalHours: 0,
        totalDerden: 0,
        totalActualDerden: 0,
        entries: []
      }
    }
    map[b.year].totalHours += parseFloat(b.budget_hours_revenue) || 0
    map[b.year].totalDerden += parseFloat(b.budget_derden_omzet) || 0
    map[b.year].totalActualDerden += parseFloat(b.actual_derden_omzet) || 0
    map[b.year].entries.push(b)
  }
  return Object.values(map).sort((a, b) => b.year - a.year)
})

function formatCurrency(amount) {
  return `\u20AC ${new Intl.NumberFormat('nl-NL').format(Math.round(amount))}`
}
</script>
